import { outputSpec, type PassportPreset } from "./passportPresets";

/** The size the download will have, the head range, and where to confirm the rules. Shown before any download. */
export function PassportSpecNote({ preset, limitLabel }: { preset: PassportPreset; limitLabel?: string }) {
  const s = outputSpec(preset);
  return (
    <div className="mt-1 space-y-1 text-xs text-muted-foreground" data-testid="passport-spec">
      <p data-testid="passport-pixels">
        Output: <strong className="text-foreground">{s.widthPx} × {s.heightPx} px</strong> at {s.dpi} dpi ({s.widthMm} × {s.heightMm} mm){limitLabel ? `, JPEG ${limitLabel.toLowerCase()}` : ""}.
      </p>
      <p>Head should fill {Math.round(preset.headMin * 100)}-{Math.round(preset.headMax * 100)}% of the photo height.</p>
      {preset.unverified && (
        <p data-testid="passport-unverified" role="note">
          Newly added: these numbers come from published specifications and have not yet been compared with the official page. Check them there before you submit.
        </p>
      )}
      <p>
        Rules can change and this tool cannot check them for you:{" "}
        <a href={preset.source} target="_blank" rel="noopener noreferrer" className="underline">official page for this document</a>.
        A correctly sized photo is not a guarantee of acceptance.
      </p>
    </div>
  );
}
